import { attachSearchEvent } from "./attachSearchEvent";
import { createArticleList } from "./createArticleList";
import { getCurrentContext } from "./getCurrentContext";
import { initPagination } from "./initPagination";



$(document).ready(function() {
    // Check whether g2Data is available
    if (window.g2Data) {
        const totalCount = window.g2Data.response.numFound;
        if(window.location.href.toLowerCase().indexOf("/search/") > 0){
        createArticleList(window.g2Data.response.docs);
    
        initPagination(totalCount);
    
        attachSearchEvent();
		
		getCurrentContext(); // This is to get the current page URL which can be used on blog article page return button
        }
    };
});
